import PropTypes from 'prop-types';
import { Card, Statistic, Skeleton } from 'antd';
import FeatherIcon from 'feather-icons-react';
import styles from './styles/AdvancedTable.module.css';

const TableSummary = ({ stats = [], loading = false }) => {
  if (!stats || stats.length === 0) return null;

  const getIconColor = type => {
    switch (type) {
      case 'success':
        return '#52c41a';
      case 'warning':
        return '#faad14';
      case 'error':
        return '#f5222d';
      case 'info':
      default:
        return '#1890ff';
    }
  };

  return (
    <div className={styles.summaryCards}>
      {stats.map((stat, index) => (
        <Card
          key={index}
          className={`${styles.summaryCard} ${stat.color ? styles[stat.color] : ''}`}
          bordered={false}
        >
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Statistic
              title={stat.title}
              value={stat.value}
              prefix={
                stat.icon ? (
                  <FeatherIcon icon={stat.icon} size={20} color={getIconColor(stat.color)} />
                ) : null
              }
              suffix={stat.suffix}
              valueStyle={{ color: getIconColor(stat.color) }}
            />
          )}
        </Card>
      ))}
    </div>
  );
};

TableSummary.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      icon: PropTypes.string,
      type: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
      color: PropTypes.string,
      suffix: PropTypes.string,
    })
  ),
  loading: PropTypes.bool,
};

export default TableSummary;
